import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "bootstrap/dist/css/bootstrap.min.css";
import "./index.css";
import { registerServiceWorker } from "./utils/serviceWorkerRegistration";
import "./i18n";

async function initializeAndRender() {
  try {
    const root = ReactDOM.createRoot(document.getElementById("root")!);
    root.render(
      <React.StrictMode>
        <App />
      </React.StrictMode>
    );

    // Register service worker for PWA (production only; auto-updates on deploy)
    registerServiceWorker();
  } catch (error) {
    console.error("Error initializing app:", error);
  }
}

initializeAndRender();